import { Button, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { FaPlus, FaRegTrashCan } from "react-icons/fa6";
import { useState } from "react";

const Numbers = ({ formData, setFormData }) => {
  const [error, setError] = useState("");
  const [newNumber, setNewNumber] = useState("");

  const handleAddNumber = () => {
    const trimmedNumber = newNumber.trim();

    if (!trimmedNumber) return;

    if (!trimmedNumber.startsWith("+")) {
      setError("Phone number must start with a '+' symbol.");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      assignNumber: [...prev.assignNumber, trimmedNumber],
      newNumbers: [...(prev.newNumbers || []), trimmedNumber],
    }));

    setError("");
    setNewNumber("");
  };

  const handleRemoveNumber = (index) => {
    setFormData((prev) => {
      const removedNumber = prev.assignNumber[index];
      const updatedNumbers = prev.assignNumber.filter((_, i) => i !== index);

      const wasNewlyAdded = (prev.newNumbers || []).includes(removedNumber);
      const newNumbers = wasNewlyAdded
        ? (prev.newNumbers || []).filter((num) => num !== removedNumber)
        : prev.newNumbers;

      return {
        ...prev,
        assignNumber: updatedNumbers,
        delNumber: wasNewlyAdded
          ? prev.delNumber || []
          : [...(prev.delNumber || []), removedNumber],
        newNumbers,
      };
    });
  };

  return (
    <Container>
      {formData.assignNumber.length > 0 &&
        formData.assignNumber.map((item, index) => (
          <Row key={index} className="align-items-center mb-3">
            <Col xs={10}>
              <Form.Control readOnly value={item} />
            </Col>
            <Col xs={2}>
              <Button
                className="w-100"
                onClick={() => handleRemoveNumber(index)}
                variant="secondary"
              >
                <FaRegTrashCan />
              </Button>
            </Col>
          </Row>
        ))}
      <InputGroup className="mb-3">
        <Form.Control
          className="me-2"
          isInvalid={!!error}
          onChange={(e) => {
            if (/^\+?\d*$/.test(e.target.value)) setNewNumber(e.target.value);
          }}
          placeholder="Add Number to Assign"
          type="tel"
          value={newNumber}
        />
        <Button
          className="rounded"
          onClick={handleAddNumber}
          variant="secondary"
        >
          <FaPlus />
        </Button>
        <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
      </InputGroup>
    </Container>
  );
};

export default Numbers;
